import React, { useState } from "react";
import GuideQuestionsContext from "./GuideQuestionsContext";
import {
  DEFAULT_GUIDES_QUESTIONS,
  DEFAULT_SUMMARY_CONTENT,
} from "../constants/questions";

function GuideQuestionsProvider({ children }: any) {
  const [questions, setQuestions] = useState(DEFAULT_GUIDES_QUESTIONS);
  const [summaryContent, setSummaryContent] = useState(DEFAULT_SUMMARY_CONTENT);
  return (
    <GuideQuestionsContext.Provider
      value={{ questions, summaryContent, setQuestions, setSummaryContent }}
    >
      {children}
    </GuideQuestionsContext.Provider>
  );
}

export default GuideQuestionsProvider;
